"use client";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SERVICES } from "@/lib/marketing/copy";
import { servicesImages } from "@/lib/marketing/images";
import { SectionHeader } from "@/components/common/SectionHeader";
import { GlassCard } from "@/components/common/GlassCard";

export function ServicesGrid() {
  return (
    <section id="services" className="zaklyn-section bg-secondary/30">
      <div className="zaklyn-container">
        <SectionHeader
          title={SERVICES.title}
          subtitle={SERVICES.subtitle}
        />

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.items.map((service, index) => {
            const image = servicesImages[index];

            return (
              <GlassCard key={service.title} delay={index * 0.1} className="overflow-hidden">
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground/30 to-transparent" />
                </div>

                <div className="p-6 md:p-8">
                  <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-muted-foreground font-body text-sm leading-relaxed">
                    {service.description}
                  </p>

                  <ul className="mt-5 space-y-2">
                    {service.features.map((feature) => (
                      <li
                        key={feature}
                        className="flex items-center gap-2 text-sm text-foreground"
                      >
                        <Check className="h-4 w-4 text-primary flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link
                    to="/customer/orders/new"
                    className="mt-6 inline-flex items-center gap-2 text-primary font-medium hover:gap-3 transition-all"
                  >
                    {service.cta}
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </GlassCard>
            );
          })}
        </div>
      </div>
    </section>
  );
}
